<template>
<w-settings-content-template>
  <div slot="content">
    <el-tabs class="content-tap" type="card" v-model="activeTab">
      <el-tab-pane label="관리대상 등록" name="WManagementDeviceRegistration" class="h100 w100">
        <w-management-device-registration ref="WManagementDeviceRegistration"></w-management-device-registration>
      </el-tab-pane>
      <el-tab-pane label="가상화 모델링" name="WModeling" class="h100 w100">
        <w-modeling :active-tab="activeTab" ref="WModeling"></w-modeling>
      </el-tab-pane>
      <el-tab-pane label="VM 및 템플릿" name="WVmTemplateManagement" class="h100 w100">
        <w-vm-template-management :active-tab="activeTab" ref="WVmTemplateManagement"></w-vm-template-management>
      </el-tab-pane>
    </el-tabs>
  </div>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WManagementDeviceRegistration from './ManagementDeviceRegistration';
import WModeling from './Modeling';
import WVmTemplateManagement from './VmTemplateManagement';

export default {
  name: 'WVirtual',
  components: {
    WSettingsContentTemplate,
    WManagementDeviceRegistration,
    WModeling,
    WVmTemplateManagement,
  },
  props: {
    title: String,
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(value) {
        this.$nextTick(() => {
          this.$refs[value].loadData();
        });
      },
    },
  },
  data() {
    return {
      activeTab: 'WManagementDeviceRegistration',
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Virtual/index.vue